import { supabase } from './supabaseClient';
import { getNegocioId } from './negocioActual';
import { registrarEvento } from './analyticsService';

// Capa de datos de COTIZACIONES. Los totales se calculan en el servidor
// (RPC guardar_cotizacion); acá solo se arma el payload y se lee.

export async function obtenerCotizaciones() {
  const { data, error } = await supabase
    .from('cotizaciones')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('creado_en', { ascending: false });
  if (error) throw error;
  return data || [];
}

export async function obtenerCotizacionCompleta(id) {
  const negocioId = getNegocioId();
  const { data: cot, error } = await supabase
    .from('cotizaciones').select('*')
    .eq('id', id).eq('negocio_id', negocioId).maybeSingle();
  if (error) throw error;
  if (!cot) return null;
  const { data: items, error: e2 } = await supabase
    .from('cotizacion_items').select('*')
    .eq('cotizacion_id', id).eq('negocio_id', negocioId)
    .order('orden', { ascending: true });
  if (e2) throw e2;
  return { ...cot, items: items || [] };
}

// Crea (id null) o edita una cotización. `items` = [{ tipo, servicio_id?,
// producto_id?, descripcion, cantidad, precio_unitario, descuento, impuesto_pct }].
export async function guardarCotizacion({
  id = null, clienteId = null, items, descuento = 0, anticipo = 0,
  notas = null, terminos = null, fechaVencimiento = null,
  fechaInicio = null, fechaFin = null, estado = 'borrador',
}) {
  const { data, error } = await supabase.rpc('guardar_cotizacion', {
    p_cotizacion_id: id,
    p_negocio_id: getNegocioId(),
    p_cliente_id: clienteId,
    p_items: items,
    p_descuento: Number(descuento) || 0,
    p_anticipo: Number(anticipo) || 0,
    p_notas: notas,
    p_terminos: terminos,
    p_fecha_vencimiento: fechaVencimiento || null,
    p_fecha_inicio: fechaInicio || null,
    p_fecha_fin: fechaFin || null,
    p_estado: estado,
  });
  if (error) throw error;
  if (!id) registrarEvento('cotizacion_creada', { estado });
  return data; // id de la cotización
}

export async function cambiarEstadoCotizacion(id, estado) {
  const { error } = await supabase
    .from('cotizaciones')
    .update({ estado, actualizado_en: new Date().toISOString() })
    .eq('id', id).eq('negocio_id', getNegocioId());
  if (error) throw error;
}

// --- Enlace público (Paso 3): el cliente abre la cotización sin cuenta ---

// Lee la cotización por su token (funciona para anónimos). Devuelve null si no
// existe. Marca la cotización como "vista" la primera vez que se abre.
// `ref` = código corto (nuevo) o token uuid (enlaces viejos). Sirven ambos.
export async function obtenerCotizacionPublica(ref) {
  const { data, error } = await supabase.rpc('obtener_cotizacion_publica', { p_ref: ref });
  if (error) throw error;
  return data; // { cotizacion, items, negocio } | null
}

// El cliente aprueba ('aprobar') o rechaza ('rechazar'). Devuelve el nuevo estado.
export async function responderCotizacionPublica(ref, accion) {
  const { data, error } = await supabase.rpc('responder_cotizacion_publica', { p_ref: ref, p_accion: accion });
  if (error) throw error;
  return data; // 'aprobada' | 'rechazada'
}

// Todos los renglones cotizados del negocio (para el reporte "lo más cotizado").
export async function obtenerItemsCotizados() {
  const { data, error } = await supabase
    .from('cotizacion_items')
    .select('descripcion, tipo, cantidad, total')
    .eq('negocio_id', getNegocioId());
  if (error) throw error;
  return data || [];
}

// Convierte una cotización APROBADA en venta (Paso 4). Crea la venta por el
// total y la deja en "Por cobrar"; devuelve el id de esa cuenta por cobrar para
// aplicarle los pagos (uno por forma de pago) como abonos.
export async function convertirCotizacion(cotizacionId) {
  const { data, error } = await supabase.rpc('convertir_cotizacion_en_venta', {
    p_cotizacion_id: cotizacionId,
    p_negocio_id: getNegocioId(),
  });
  if (error) throw error;
  registrarEvento('cotizacion_convertida', {});
  return data; // cxc_id (cuenta por cobrar)
}

export async function eliminarCotizacion(id) {
  const { error } = await supabase
    .from('cotizaciones').delete()
    .eq('id', id).eq('negocio_id', getNegocioId());
  if (error) throw error; // los renglones caen por cascada
}
